
(function () {
  /*
   * SMAGdansk – globalt variantgalleri
   *
   * Viser billeder til den valgte variant samt eventuelle
   * fælles produktbilleder.
   *
   * Skjuler billeder, der er knyttet til andre varianter.
   *
   * Gælder automatisk alle produkter med mindst 2 varianter
   * og mindst ét tilknyttet variantbillede.
   */

  function getProduct(section) {
    const json = section.querySelector("[data-js-product-json]");

    if (!json) return null;

    try {
      return JSON.parse(json.textContent);
    } catch (e) {
      console.warn(
        "SMAGdansk: Kunne ikke læse produktdata.",
        e
      );
      return null;
    }
  }

  function waitForSlider(section, callback, attempts = 0) {
    const sliderEl = section.querySelector(
      "[data-js-product-media-slider]"
    );

    if (sliderEl && sliderEl.swiper) {
      callback(sliderEl);
      return;
    }

    if (attempts >= 50) return;

    setTimeout(function () {
      waitForSlider(section, callback, attempts + 1);
    }, 100);
  }

  function initSection(section) {
    /*
     * Undgå at initialisere samme produktsektion flere gange.
     */
    if (section.dataset.smagdanskGalleryInitialized === "true") {
      return;
    }

    const product = getProduct(section);

    /*
     * Kør kun på produkter med mindst 2 varianter.
     */
    if (
      !product ||
      !Array.isArray(product.variants) ||
      product.variants.length < 2
    ) {
      return;
    }

    /*
     * Find alle billeder, der er knyttet til varianter.
     */
    const variantMediaIds = new Set(
      product.variants
        .map(function (variant) {
          return variant.featured_media &&
            variant.featured_media.id
            ? String(variant.featured_media.id)
            : null;
        })
        .filter(Boolean)
    );

    /*
     * Hvis ingen varianter har tilknyttede billeder,
     * lader vi det normale produktgalleri være uændret.
     */
    if (variantMediaIds.size === 0) return;

    waitForSlider(section, function (sliderEl) {
      if (
        section.dataset.smagdanskGalleryInitialized === "true"
      ) {
        return;
      }

      const slider = sliderEl.swiper;

      const mediaContainer = section.querySelector(
        ".js-product-media-container"
      );

      if (!mediaContainer) return;

      const mainWrapper = sliderEl.querySelector(
        ".swiper-wrapper"
      );

      if (!mainWrapper) return;

      const thumbnailSliderEl = section.querySelector(
        '[class*="js-product-media-slider-thumbnails-"]'
      );

      const thumbnailSwiper =
        thumbnailSliderEl && thumbnailSliderEl.swiper
          ? thumbnailSliderEl.swiper
          : null;

      const thumbnailWrapper = thumbnailSliderEl
        ? thumbnailSliderEl.querySelector(".swiper-wrapper")
        : null;

      const zoomWrapper = section.querySelector(
        "[data-zoom-content]"
      );

      /*
       * Gem det oprindelige komplette galleri.
       * Billederne skal kunne genskabes ved variantskift.
       */
      const originalSlides = [
        ...mainWrapper.querySelectorAll(
          ".js-product-gallery-slide"
        )
      ].map(function (slide) {
        return slide.cloneNode(true);
      });

      if (originalSlides.length === 0) return;

      const originalThumbnails = thumbnailWrapper
        ? [...thumbnailWrapper.children].map(function (thumb) {
            return thumb.cloneNode(true);
          })
        : [];

      const originalZoomSlides = zoomWrapper
        ? [
            ...zoomWrapper.querySelectorAll(
              "[data-zoom-slide]"
            )
          ].map(function (slide) {
            return slide.cloneNode(true);
          })
        : [];

      /*
       * Markér sektionen som initialiseret.
       */
      section.dataset.smagdanskGalleryInitialized = "true";

      /*
       * Skal et billede vises?
       *
       * 1. Fælles produktbilleder vises altid.
       * 2. Variantbilleder vises kun for valgt variant.
       */
      function shouldShowMedia(mediaId, selectedMediaId) {
        if (!variantMediaIds.has(mediaId)) {
          return true;
        }

        return mediaId === selectedMediaId;
      }

      /*
       * Videoer og 3D-modeller bevares som fælles medier.
       */
      function isSharedMediaType(mediaType) {
        return (
          mediaType === "video" ||
          mediaType === "external_video" ||
          mediaType === "model"
        );
      }

      /*
       * Opdater hele produktgalleriet.
       */
      function updateGallery(variant) {
        if (!variant) return;

        /*
         * Find variantens komplette produktdata.
         */
        const selectedVariant =
          product.variants.find(function (item) {
            return String(item.id) === String(variant.id);
          }) || variant;

        const featuredMedia =
          selectedVariant.featured_media ||
          variant.featured_media;

        const selectedMediaId =
          featuredMedia && featuredMedia.id
            ? String(featuredMedia.id)
            : null;

        /*
         * HOVEDGALLERI
         */
        const slidesToShow = originalSlides.filter(
          function (slide) {
            const mediaId = String(
              slide.dataset.mediaId || ""
            );

            const mediaType = slide.dataset.mediaType;

            if (isSharedMediaType(mediaType)) {
              return true;
            }

            return shouldShowMedia(
              mediaId,
              selectedMediaId
            );
          }
        );

        /*
         * Undgå et helt tomt galleri, hvis varianten
         * ikke har et billede eller en gyldig mediemapping.
         */
        if (slidesToShow.length === 0) {
          return;
        }

        mainWrapper.innerHTML = "";

        slidesToShow.forEach(function (slide) {
          mainWrapper.appendChild(
            slide.cloneNode(true)
          );
        });

        /*
         * Genindlæs billeder via Ultra.
         */
        if (
          window.themeCore &&
          window.themeCore.LazyLoadImages
        ) {
          window.themeCore.LazyLoadImages.init();
        }

        slider.update();
        slider.slideTo(0, 0);

        /*
         * THUMBNAILS
         */
        if (thumbnailWrapper) {
          const thumbsToShow =
            originalThumbnails.filter(function (thumb) {
              const mediaId = String(
                thumb.dataset.mediaId || ""
              );

              const mediaType = thumb.dataset.mediaType;

              if (isSharedMediaType(mediaType)) {
                return true;
              }

              return shouldShowMedia(
                mediaId,
                selectedMediaId
              );
            });

          thumbnailWrapper.innerHTML = "";

          thumbsToShow.forEach(function (thumb) {
            thumbnailWrapper.appendChild(
              thumb.cloneNode(true)
            );
          });

          if (thumbnailSwiper) {
            thumbnailSwiper.update();

            if (thumbsToShow.length > 0) {
              thumbnailSwiper.slideTo(0, 0);
            }
          }
        }

        /*
         * ZOOM-GALLERI
         */
        if (
          zoomWrapper &&
          originalZoomSlides.length > 0
        ) {
          const zoomSlidesToShow =
            originalZoomSlides.filter(function (zoomSlide) {
              const mediaId = String(
                zoomSlide.dataset.zoomSlide || ""
              );

              return shouldShowMedia(
                mediaId,
                selectedMediaId
              );
            });

          zoomWrapper.innerHTML = "";

          zoomSlidesToShow.forEach(function (slide) {
            zoomWrapper.appendChild(
              slide.cloneNode(true)
            );
          });

          if (
            window.themeCore &&
            window.themeCore.EventBus
          ) {
            window.themeCore.EventBus.emit(
              "zoom:slides-updated"
            );
          }
        }

        /*
         * Skjul galleriets pile, når der kun
         * er ét relevant billede.
         */
        const navigation =
          mediaContainer.querySelector(
            ".product-media__navigation"
          );

        if (navigation) {
          navigation.classList.toggle(
            "is-hidden",
            slidesToShow.length <= 1
          );
        }

        /*
         * Deaktivér swipe ved kun ét billede.
         * Aktivér det igen ved flere billeder.
         */
        slider.allowTouchMove =
          slidesToShow.length > 1;
      }

      /*
       * FØRSTE SIDEINDLÆSNING
       */
      const variantInput = section.querySelector(
        'input[name="id"]'
      );

      if (variantInput) {
        const initialVariant =
          product.variants.find(function (variant) {
            return (
              String(variant.id) ===
              String(variantInput.value)
            );
          });

        if (initialVariant) {
          updateGallery(initialVariant);
        }
      }

      /*
       * NÅR KUNDEN VÆLGER EN ANDEN VARIANT
       */
      const sectionId = section.dataset.sectionId;

      if (
        sectionId &&
        window.themeCore &&
        window.themeCore.EventBus
      ) {
        window.themeCore.EventBus.listen(
          `pdp:section-${sectionId}:change-variant`,
          function (data) {
            if (!data || !data.variant) return;

            /*
             * Lad Ultra afslutte sit eget variantskift.
             */
            setTimeout(function () {
              updateGallery(data.variant);
            }, 0);
          }
        );
      }
    });
  }

  /*
   * INITIALISERING PÅ ALLE PRODUKTSIDER
   */
  function init() {
    document
      .querySelectorAll(
        '[data-section-type="product"]'
      )
      .forEach(initSection);
  }

  /*
   * Understøt indlæsning i Shopify Theme Editor.
   */
  document.addEventListener(
    "shopify:section:load",
    init
  );

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      init,
      { once: true }
    );
  } else {
    init();
  }
})();
